<template>
  <BbBtn
    :class="{ selected: isSaved }"
    size="large"
    type="icon"
    :icon="icon"
    icon-size="small"
    no-background
    :icon-type="iconType"
    @click="handleCollection"
  ></BbBtn>
</template>

<script>
import useCollections from '~/composables/useCollections';
import { computed } from 'vue';
import { COLLECTIONS } from '~/constants/collections';

export default {
  props: {
    document: {
      type: [String, Object],
      default: () => {},
    },
    collectionId: {
      type: String,
      default: COLLECTIONS.favorites,
    },
  },

  setup(props) {
    const { handleCollections, isInCollection } = useCollections();

    const isSaved = computed(() => isInCollection(props.collectionId, props.document.externalId).value);
    const icon = computed(() =>
      props.collectionId === COLLECTIONS.favorites ? 'heart' : isSaved.value ? 'zoomminus' : 'plus-small',
    );
    const iconType = computed(() =>
      isSaved.value && props.collectionId === COLLECTIONS.favorites ? 'filled' : 'outlined',
    );

    const handleCollection = () => handleCollections(props.document, props.collectionId);

    return {
      handleCollection,
      icon,
      iconType,
      isSaved,
    };
  },
};
</script>

<style scoped lang="scss">
.selected {
  border: 1px solid $bb-primary-3 !important;
  background-color: $bb-interface-8 !important;

  :deep(.v-btn__content) {
    color: $bb-primary-3;
  }
}
</style>
